export const DEFAULT_CONTAINER_STATE = {
  NONE: ''
}

export const SALE_PROCESS_STEP = {
  DEPOSIT: 'deposit',
  CONNECT_ACCOUNT: 'connectAccount',
  SUCCESS: 'success',
  DEPOSIT_SUCCESS: 'depositSuccess',
  REWARDS_BOOSTERS: 'rewardsBoosters'
}
